var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpendropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61403 0.683913C4.44272 0.274658 3.86288 0.274659 3.69158 0.683914L0.413403 8.51559C0.275505 8.84504 0.51749 9.20865 0.874628 9.20865L7.43097 9.20865C7.78811 9.20865 8.0301 8.84504 7.8922 8.51559L4.61403 0.683913Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpendropdown);
export default __webpack_public_path__ + "static/media/opendropdown.e00b80762c445bc76bb484b150d6877b.svg";
export { ForwardRef as ReactComponent };